import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NavController } from 'ionic-angular';
import { UserData } from '../../providers/user-data';
import { TabsPage } from '../tabs/tabs';
import {LoggerService} from '../../providers/logger-service';

declare var dataLayer: Array<any>;

@Component({
  selector: 'page-user',
  templateUrl: 'signup.html'
})
export class SignupPage {
  signup: {username?: string, password?: string} = {};
  submitted = false;

  constructor(public navCtrl: NavController,
              public userData: UserData,
              private logger: LoggerService) {}

  onSignup(form: NgForm) {
    this.submitted = true;

    if (form.valid) {
      this.userData.signup(this.signup.username);
      this.navCtrl.push(TabsPage);

      dataLayer.push({
        'appEventCategory': 'user',
        'appEventAction': 'onSignup',
        'appEventLabel': 'onSignup button'
      });
      dataLayer.push({'event': 'appEvent'});

    }else {

      dataLayer.push({
        'appEventCategory': 'user',
        'appEventAction': 'onSignupFailure',
        'appEventLabel': 'onSignup button failure'
      });
      dataLayer.push({'event': 'appEvent'});

      //http://www.charlesfarina.com/login-and-signup-naming-conventions-for-google-analytics/
      this.logger.log.warn('you need correct variables to log in');

    }
  }

  ionViewDidLoad() {
    dataLayer.push({
      'screenPath': 'user',
      'screenName': 'SignupPage'
    });
    dataLayer.push({'event': 'appScreenView'});
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts